//https://medium.com/weekly-webtips/how-to-make-an-effective-exit-intent-popup-in-javascript-bf6051b4a6d4
import $ from 'jquery';
 


let inactivityTime = function (timeout, callback) {
    var time;
    window.onload = resetTimer;
    // DOM Events
      $(document).on('mousemove', resetTimer);
      $(document).on('onkeypress', resetTimer);

    function finished() {
        console.log('fin');
        $(document).off('mousemove', resetTimer);
        $(document).off('onkeypress', resetTimer);
        callback();
    }

    function resetTimer() {
        clearTimeout(time);
        time = setTimeout(finished, timeout)
        // 1000 milliseconds = 1 second
    }
};


export default inactivityTime;